import React, { Component } from 'react';

import { Header, Navbar } from '@C';
import { CreditSale } from '@C/CreditCustomerProfile/CreditSale';
import ErrorBoundary from '@C/Error';

class CreditSalePage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    return (
      <main>
        <div className="page-wrapper">
          <Header title="Create dealer" />
          <Navbar />
          <div className="page-content">
            <section className="page-components">
              <ErrorBoundary>
                <CreditSale />
              </ErrorBoundary>
            </section>
          </div>
        </div>
      </main>
    );
  }
}

export { CreditSalePage };
